module.exports = __webpack_public_path__ + "media/images/pen_lightgrey-5e71733f.png";